import React from 'react'
import {
  CURRENT_AWARENESS,
  LEGISLATION,
  LEGISLATION_FOLDERS,
  QA_CONTENT,
  QA_MENU,
  SEARCH,
  SMART_SEARCH
} from 'constants/controllers'
import SmartSearchHeader from 'pages/smartsearch/Header'
import QaFolderHeader from 'components/tiled-menu/Header'
import LegFoldersHeader from 'pages/legislationfolders/Header'
import LegislationBreadCrumbsContainer from 'redux/containers/pages/legislation/LegislationBreadCrumbsContainer'
import TitleContainer from 'redux/containers/components/qa/TitleContainer'
import { get } from 'libraries/lodash'

const HeaderAppendProxy = ({ controller, url, pageParameters }) => {
  const searchType = url.split('/').slice(-1)[0]
  switch (controller) {
    case SMART_SEARCH:
      return <SmartSearchHeader />
    case QA_MENU:
      return <QaFolderHeader isProxy flavours={get(pageParameters, 'flavours', [])} />
    case LEGISLATION_FOLDERS:
      return <LegFoldersHeader isProxy />
    case LEGISLATION:
      return <LegislationBreadCrumbsContainer isProxy />
    case QA_CONTENT:
      return <TitleContainer isProxy />
    case CURRENT_AWARENESS:
      return <div className='min-h3 mt4 mb8-m' />
    case SEARCH:
      switch (searchType) {
        case 'qa':
          return <QaFolderHeader isProxy isSearch />
        case 'ca':
          return <div className='min-h3 mt4 mb8-m' />
        default:
          break
      }
      return null
    default :
      return null
  }
}

export default HeaderAppendProxy
